var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_109_1441)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.58577 2.30007C6.96085 1.92499 7.46956 1.71429 7.99999 1.71429C8.53043 1.71429 9.03913 1.92499 9.41421 2.30007C9.65119 2.53706 9.82256 2.82739 9.91662 3.14286H6.08336C6.17742 2.82739 6.34879 2.53706 6.58577 2.30007ZM4.32991 3.14286C4.45033 2.36938 4.81317 1.64831 5.37359 1.08789C6.07016 0.391326 7.01491 0 7.99999 0C8.98508 0 9.92982 0.391326 10.6264 1.08789C11.1868 1.64831 11.5497 2.36938 11.67 3.14286H14.8571C15.3305 3.14286 15.7143 3.52662 15.7143 4C15.7143 4.47339 15.3305 4.85714 14.8571 4.85714H13.7143V14.2857C13.7143 14.7403 13.5337 15.1765 13.2122 15.4979C12.8907 15.8194 12.4546 16 12 16H3.99999C3.54533 16 3.10929 15.8194 2.78781 15.4979C2.46632 15.1765 2.28571 14.7403 2.28571 14.2857V4.85714H1.14285C0.669461 4.85714 0.285706 4.47339 0.285706 4C0.285706 3.52662 0.669461 3.14286 1.14285 3.14286H4.32991ZM5.71428 6.71595C6.10877 6.71595 6.42856 7.03576 6.42856 7.43024V12.0034C6.42856 12.3978 6.10877 12.7177 5.71428 12.7177C5.31979 12.7177 4.99999 12.3978 4.99999 12.0034V7.43024C4.99999 7.03576 5.31979 6.71595 5.71428 6.71595ZM11 7.43024C11 7.03576 10.6802 6.71595 10.2857 6.71595C9.89121 6.71595 9.57142 7.03576 9.57142 7.43024V12.0034C9.57142 12.3978 9.89121 12.7177 10.2857 12.7177C10.6802 12.7177 11 12.3978 11 12.0034V7.43024Z",
    fill: "#DB0035"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_109_1441"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.1c57a0d202af16f76fcd0fa04651a2f9.svg";
export { ForwardRef as ReactComponent };